import { h } from 'preact';
import { Text } from 'preact-i18n';

/**
 * Small "Live" affordance for the convention detail page. Shows a green dot +
 * "Live" label so users trust the page auto-updates (and stop pull-to-refreshing).
 * The dot re-pulses whenever `lastUpdate` changes — keying the node on `lastUpdate`
 * restarts the CSS animation, the same trick refreshCountdown.js uses with `cycle`.
 * Renders nothing when the live consumer is not active.
 */
function LiveIndicator({ active, lastUpdate = 0 }) {
    if (!active) {
        return null;
    }
    return (
        <span
            class='d-inline-flex align-items-center text-body-secondary ms-2'
            style='font-size: 0.8rem; vertical-align: middle;'
            title='Live'
        >
            <style>{`
                @keyframes convention-live-pulse {
                    0% { opacity: 1; transform: scale(1); }
                    50% { opacity: 0.35; transform: scale(1.7); }
                    100% { opacity: 1; transform: scale(1); }
                }
            `}</style>
            <span
                key={lastUpdate}
                class='bg-success rounded-circle me-1'
                style='display: inline-block; width: 8px; height: 8px; animation: convention-live-pulse 0.6s ease-out;'
            />
            <Text id='convention.live'>Live</Text>
        </span>
    );
}

export default LiveIndicator;
